import { z } from 'zod/v3';

// User DTOs
export const UserDTOSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
  email: z.string().optional(),
  image: z.string().optional(),
  role: z.string().optional(),
  accounts: z.array(z.string()),
  flows: z.array(z.string()),
  userRoles: z.array(z.string()),
  Members: z.array(z.string()),
  Invitations: z.array(z.string()),
  Workspaces: z.array(z.string())
}).strict();

export const UserListDTOSchema = z.object({
  id: z.string(),
  name: z.string().optional()
}).strict();

export const CreateUserDTOSchema = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  image: z.string().optional(),
  role: z.string().optional(),
  accounts: z.array(z.string()),
  flows: z.array(z.string()),
  userRoles: z.array(z.string()),
  Members: z.array(z.string()),
  Invitations: z.array(z.string()),
  Workspaces: z.array(z.string())
}).strict();

export const UpdateUserDTOSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
  email: z.string().optional(),
  image: z.string().optional(),
  role: z.string().optional(),
  accounts: z.array(z.string()).optional(),
  flows: z.array(z.string()).optional(),
  userRoles: z.array(z.string()).optional(),
  Members: z.array(z.string()).optional(),
  Invitations: z.array(z.string()).optional(),
  Workspaces: z.array(z.string()).optional()
}).strict();

export type UserDTO = z.infer<typeof UserDTOSchema>;
export type UserListDTO = z.infer<typeof UserListDTOSchema>;
export type CreateUserDTO = z.infer<typeof CreateUserDTOSchema>;
export type UpdateUserDTO = z.infer<typeof UpdateUserDTOSchema>;
